import { api } from "../api";

/**
 * findAllUsersExportResponse - Function that finds on database all accesses by customer and export in a PDF/XSLX file  
 * /users/{customerType}/{customerId}/{status}/{exportType}  
 * method GET  
 * @async-function
 */
const findAllUsersExportResponse = async (token: string, customerId: number, status: string, exportType: string, customerType: string, simpleXlsxExport = false) => {
    const response = await api.get(
        `/users/${customerType}/${customerId}/${status}/${exportType}/export?simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findAllUsersExportResponse;